const userSelector = (state: any) => state.user;
const roleSelector = (state: any) => state.role;
const orgSelector = (state: any) => state.org;
const locationSelector = (state: any) => state.location;

export { userSelector, roleSelector, orgSelector, locationSelector };
